'use client';
import Anchor from '@ui/Anchor/Anchor';
import { Button } from '@ui/Button/Button';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import { getLanguageFromPathname, getLanguageHref } from '@utils/pathname';
import { usePathname } from 'next/navigation';

type BackToHomepageButtonProps = {
  style?: React.CSSProperties;
};

export function BackToHomepageBtn({ style }: BackToHomepageButtonProps) {
  const pathname = usePathname();
  const language = getLanguageFromPathname(pathname);

  return (
    <Button style={style} variant="primary" size="xl" className="mt-8" asChild>
      <Anchor href={getLanguageHref('/', language.id)} className="flex items-center gap-1.5">
        <StaticIcon icon={IconType.arrowRight} className="fill-primary-foreground rotate-180" svgClassName="h-6 w-6" />
        Back to Homepage
      </Anchor>
    </Button>
  );
}
